import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transition: height 300ms;
    overflow: hidden;
    pointer-events: none;
`;

export const Background = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    height: 500px;
    min-height: 100%;
    bottom: 0;

`;